<template>
    <div :class="'character-count-' + countPosition" class="jgile-textarea">
        <textarea
            class="form-control"
            v-model="fieldValue"
            :name="name"
            :placeholder="placeholder"
            :id="fieldId"
            :dusk="fieldId + 'Field'"
            :rows="rows"
        ></textarea>
        <div class="character-count" :class="{ 'text-danger': characterCount > maxLength }" v-if="showCount">
            {{ characterCount }}
            <template v-if="maxLength">/{{ maxLength }}</template>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
        placeholder: {
            type: String,
        },
        showCount: {
            type: Boolean,
            default: false,
        },
        rows: {
            type: [String, Number],
            default: 3,
        },
        countPosition: {
            type: String,
            default: 'top',
            validator: function (value) {
                return ['top', 'bottom'].indexOf(value) !== -1;
            },
        },
        maxLength: {
            default: null,
        },
    },
    data: () => ({
        fieldValue: null,
    }),
    computed: {
        fieldId() {
            return this.id ? this.id : `${this.name}Field`;
        },
        characterCount() {
            return _.isString(this.fieldValue) ? this.fieldValue.length : 0;
        },
    },
    watch: {
        value: {
            deep: true,
            immediate: true,
            handler(newVal, oldVal) {
                if (newVal === oldVal) return;
                this.fieldValue = newVal;
            },
        },
        fieldValue: {
            deep: true,
            handler(newVal) {
                this.$emit('input', newVal);
            },
        },
    },
};
</script>
